"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const styles = react_native_1.StyleSheet.create({
    modalPositionBottom: {
        top: '40%',
        height: 150,
    },
    modalStyle: {
        backgroundColor: theme_1.default.colors.COLOR_WHITE,
        height: 280,
        padding: 30,
        borderRadius: 18,
    },
});
exports.default = styles;
